import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
export interface DialogData {
  animal: string;
  name: string;
}
@Component({
  selector: 'app-auto-generate-content',
  templateUrl: './auto-generate-content.component.html',
  styleUrls: ['./auto-generate-content.component.css']
})
export class AutoGenerateContentComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AutoGenerateContentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {
  }

}
